// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UpgradePrompt_wrapper__3ARg7"};